import { Order } from '@customTypes/order';

export enum OrderType {
  SINGLE_GENE = 'SINGLE_GENE',
  RISK_SCORE = 'RISK_SCORE',
  PGX = 'PGX',
  APOE = 'APOE',
}

export interface ResultOrder extends Order {
  type?: OrderType; // Default is PGX
}
